import * as React from "react";
import { Tooltip } from "@mui/material";

const SvgComponent = (props) => (
  <Tooltip title="show scorecard with ready status" arrow>
            <span>
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      stroke="var(--filter-bar-btn-border)"
    />
    <path
      d="m10.647 14.528 2.58 4.362c2.672-4.174 5.674-7.832 8.394-9.942.61-.563 1.547-.234.89.375-3.048 3.142-5.392 6.706-7.784 12.286-.938.657-2.016.985-2.532.375l-3.377-6.049c-.469-.75 1.173-2.485 1.83-1.407Z"
      fill="var(--theme-text)"
      opacity={0.6}
    />
  </svg>
  </span>
  </Tooltip>
);

export default SvgComponent;
